<template>
  <div class="page-login">
    <div class="nav">
      <div class="logo-container">
        <i :class="`logo ${isHL() ? 'logo-hl' : ''}`"></i>
        <span>{{title}}平台</span>
      </div>
    </div>
    <div class="content">
      <div  :class="`img ${isHL() ? 'img-hl' : ''}`"></div>
       <div class="form-data">
        <div class="title">欢迎使用{{title}}平台</div>
        <div class="form-item-box">
          <i class="icon-account" />
          <el-input
            v-model="form.username"
            class="input"
            placeholder="请输入账号"
          />
        </div>
        <div class="form-item-box">
          <i class="icon-password" />
          <el-input
            v-model="form.password"
            class="input"
            placeholder="请输入密码"
            show-password
          />
        </div>
        <div class="container">
          <div class="form-item-box new">
            <i class="icon-code" />
            <el-input
              v-model="form.code"
              class="input"
              placeholder="请输入验证码"
            />
          </div>
          <el-image
            class="code-image"
            :src="codeUrl"
            fit="fill"
            @click="getUserLoginCode"
          />
        </div>
        <a
          v-loading="loading"
          class="btn-login"
          @click="doLogin"
        >
          {{ loading ? '登录中' : '登录' }}
        </a>
      </div>
    </div>
    <div class="icp-text" @click="handleJumpBeian()">
      <div v-for="(t, i) in icpText" :key="i">{{ t }}</div>
    </div>
  </div>
</template>

<script>
import { getUserLoginCode, doPasswordLogin } from '@/apis/login.js';
// import { localStorage } from '@/common/storage';
import { TOKEN } from '@/common/storageKeys';
import { isHL, getPlatformTitle, getICP } from '@/common/utils';

export default {
  data() {
    return {
      form: {
        username: '',
        password: '',
        code: '',
      },
      codeUrl: '',
      loading: false,
      captchaId: '',
      title: getPlatformTitle(),
      isHL: isHL,
      icpText: getICP()
    };
  },
  created() {
    this.getUserLoginCode();
  },
  methods: {
    async getUserLoginCode() {
      const res = await getUserLoginCode();
      this.$ls.set('captchaId', res.headers['captcha-id']);
      let reader = new FileReader();
      let me = this;
      reader.onload = function(e) {
        me.codeUrl = e.target.result;
      };
      reader.readAsDataURL(res.data);
    },
    async doLogin() {
      const { username = '', password = '', code = '' } = this.form;
      if (!username) {
        this.$message.error('请输入用户名');
        return;
      }
      if (!password) {
        this.$message.error('请输入密码');
        return;
      }
      if (!code) {
        this.$message.error('请输入验证码');
        return;
      }
      this.loading = true;
      const res = await doPasswordLogin({
        ...this.form,
        captcha_id: this.$ls.get('captchaId'),
      }).finally(() => {
        this.loading = false;
      });
      this.$ls.set(TOKEN, res.data.token);
      this.$router.push('/');
    },
    handleJumpBeian() {
      window.open('https://beian.miit.gov.cn', '_blank');
    }
  },
};
</script>

<style lang="scss">
.page-login {
  .form-item-box {
    .input {
      .el-input__inner {
        border: none;
        padding-left: 0;
      }
    }
  }
}
</style>


<style lang="scss" scoped>
.page-login {
  width: 100%;
  height: 100%;
  background: #F3F7F9;
  position: relative;
  display: flex;
  flex-direction: column;
  .nav {
    flex-shrink: 0;
    width: 100%;
    height: 70px;
    background: #FFFFFF;
    box-shadow: 0px 1px 5px 0px rgba(220, 222, 224, 0.4);
    line-height: 70px;
    .logo-container {
      margin-left: 60px;
      display: flex;
      align-items: center;
      .logo {
          width: 80px;
          height: 23px;
          display: block;
          background-image: url('~@/assets/images/logo.png');
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          margin-right: 10px;
          &.logo-hl {
            background-image: url('~@/assets/images/logo_hl.png');
          }
      }
      span {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #303133;
      }
    }
  }
  .content {
    flex-grow: 1;
    display: flex;
    overflow: hidden;
    margin-top: 24px;
    position: relative;
    width: 100%;
    .img {
      display: block;
      width: 848px;
      height: 492px;
      overflow: hidden;
      background-image: url('./images/img.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      margin-left: calc((100% - 848px - 360px)/3);
      &.img-hl {
        background-image: url('./images/img_hl.png');
      }
    }
    .form-data {
      width: 360px;
      height: 492px;
      background: #FFFFFF;
      box-shadow: 0px 1px 5px 0px rgba(220, 222, 224, 0.4);
      border-radius: 4px;
      position: absolute;
      right: calc((100% - 848px - 360px)/3);
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        padding: 58px 0 45px;
        font-size: 26px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #4F90FF;
        line-height: 37px;
      }
      .container {
        display: flex;
        justify-content: space-between;
        width: 284px;
        .new {
          width: 140px;
        }
        .code-image {
          flex-shrink: 0;
          width: 120px;
          height: 40px;
          border-left: 1px solid #e6e7eb;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
          margin-top: 22px;
        }
      }
      .form-item-box {
        margin-top: 22px;
        display: flex;
        align-items: center;
        width: 284px;
        height: 40px;
        background: rgba(255, 255, 255, 0);
        border: 1px solid #CACED4;
        box-sizing: border-box;
        border-radius: 4px;
        overflow: hidden;
        .icon-account {
          flex-shrink: 0;
          display: inline-block;
          width: 36px;
          height: 40px;
          background-image: url('./images/icon_account.png');
          background-position: center;
          background-size: 16px 16px;
          background-repeat: no-repeat;
        }
        .icon-password {
          flex-shrink: 0;
          display: inline-block;
          width: 36px;
          height: 40px;
          background-image: url('./images/icon_password.png');
          background-position: center;
          background-size: 18px 18px;
          background-repeat: no-repeat;
        }
        .icon-code {
          flex-shrink: 0;
          display: inline-block;
          width: 36px;
          height: 40px;
          background-image: url('./images/icon_code.png');
          background-position: center;
          background-size: 16px 16px;
          background-repeat: no-repeat;
        }
        .input {
          flex-grow: 1;
          .el-input__inner {
            border: none;
          }
        }
      }
      .btn-login {
        margin-top: 44px;
        display: inline-block;
        width: 284px;
        height: 40px;
        line-height: 40px;
        background: #4F90FF;
        border-radius: 4px;
        border: 1px solid #4F90FF;
        font-family:  PingFangSC-Regular, PingFang SC;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        text-align: center;
        color: #ffffff;
      }
    }
  }
  .icp-text {
    flex-shrink: 0;
    width: 100%;
    height: 60px;
    line-height: 30px;
    text-align: center;
    color: #989898;
    cursor: pointer;
  }
}
</style>